// @flow
import React from 'react';
import PropTypes from 'prop-types';
import {Redirect, Route} from 'react-router-dom';
import {connect} from 'react-redux';

import {useLocation} from 'react-router-dom';
import type {Currency, Store, User} from '../entities';
import type {RootState} from '../modules';
import {ON_BOARDING_TYPE} from '../modules/on-boarding/utils/constants';

// const ONBOARDING_TRIAL_IDS = [2, 3, 4];

type Props = {|
  exact?: boolean,
  path: string,
  component: any,
  componentProps?: any,
  user?: User,
  initialAuthDone?: boolean,
  currency?: Currency,
  isFetchingCurrency?: boolean,
  store?: Store,
  isFetchingStore?: boolean,
  cardProfiles?: any[],
|};

export const SKIP_INITIAL_CONFIG_STORAGE_KEY = 'skip_initial_config';

const _PrivateRoute = ({
  component: Component,
  componentProps,
  user,
  initialAuthDone,
  currency,
  isFetchingCurrency,
  store,
  isFetchingStore,
  cardProfiles,
  ...rest
}: Props) => {
  const location = useLocation();

  const hasAtLeastOneCard = cardProfiles ? cardProfiles.length > 0 : false;

  return (
    <Route
      {...rest}
      render={props => {
        const skipInitialConfig =
          localStorage.getItem(SKIP_INITIAL_CONFIG_STORAGE_KEY) === 'true';
        if (!initialAuthDone || isFetchingCurrency || isFetchingStore)
          return null;
        const content = <Component {...componentProps} />;

        if (!!user) {
          if (skipInitialConfig) return content;
          if (!store?.initialConfig && location.pathname !== '/on-boarding') {
            return (
              <Redirect
                to={{
                  pathname: '/on-boarding',
                  search: location.search,
                }}
              />
            );
          } else if (
            // Provisional validation on TIER_0 for new onborading purposes
            store?.initialConfig &&
            store?.storeTier?.name === 'TIER_0' &&
            ([2, 4].includes(store.onboardingTypeId) ||
              (store.onboardingTypeId === ON_BOARDING_TYPE.FULL_PAYMENT &&
                !hasAtLeastOneCard)) &&
            location.pathname !== '/on-boarding/trial'
          )
            return (
              <Redirect
                to={{
                  pathname: '/on-boarding/trial',
                  search: location.search,
                }}
              />
            );
          else return content;
        } else {
          return (
            <Redirect
              to={{
                pathname: '/login',
                search: location.search,
                state: {referrer: location.pathname},
              }}
            />
          );
        }
      }}
    />
  );
};

export const PrivateRoute = connect((state: RootState) => ({
  user: state.auth.user,
  initialAuthDone: state.auth.initialAuthDone,
  currency: state.currency.currency,
  isFetchingCurrency: state.currency.isFetchingCurrency,
  store: state.store.store,
  isFetchingStore: state.store.isFetching,
  cardProfiles: state.checkout.cardProfiles,
}))(_PrivateRoute);

_PrivateRoute.propTypes = {
  exact: PropTypes.bool,
  path: PropTypes.string.isRequired,
  component: PropTypes.any.isRequired,
  componentProps: PropTypes.object,
  user: PropTypes.object,
  initialAuthDone: PropTypes.bool,
  currency: PropTypes.object,
  isFetchingCurrency: PropTypes.bool,
  store: PropTypes.object,
  isFetchingStore: PropTypes.bool,
  cardProfiles: PropTypes.array,
};
